/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface UpdateLeagueResponse
 */
export interface UpdateLeagueResponse {
    /**
     * 
     * @type {LeagueResponse}
     * @memberof UpdateLeagueResponse
     */
    league: LeagueResponse;
}

/**
 * Check if a given object implements the UpdateLeagueResponse interface.
 */
export function instanceOfUpdateLeagueResponse(value: object): value is UpdateLeagueResponse {
    if (!('league' in value) || value['league'] === undefined) return false;
    return true;
}

export function UpdateLeagueResponseFromJSON(json: any): UpdateLeagueResponse {
    return UpdateLeagueResponseFromJSONTyped(json, false);
}

export function UpdateLeagueResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeagueResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'league': LeagueResponseFromJSON(json['league']),
    };
}

export function UpdateLeagueResponseToJSON(json: any): UpdateLeagueResponse {
    return UpdateLeagueResponseToJSONTyped(json, false);
}

export function UpdateLeagueResponseToJSONTyped(value?: UpdateLeagueResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'league': LeagueResponseToJSON(value['league']),
    };
}

